const DEFAULT_STATUS_COLOR = 'dark:bg-gray-700 bg-gray-500 text-white'
const DEFAULT_STATUS_HEX_COLOR = '#6b7280'

type StatusColorConfig = {
  className: string
  hex: string
}

const GLOBAL_STATUS_COLOR_CONFIG: Record<string, StatusColorConfig> = {
  DRAFT: { className: 'dark:bg-slate-700 bg-slate-500 text-white', hex: '#64748b' },
  REVIEW_REQUESTED: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  REVIEW: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  UNDER_REVIEW: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  IN_REVIEW: { className: 'dark:bg-purple-700 bg-purple-500 text-white', hex: '#a855f7' },
  REVIEWED: { className: 'dark:bg-teal-800 bg-teal-600 text-white', hex: '#0d9488' },
  SENT: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  IN_PROGRESS: { className: 'dark:bg-cyan-700 bg-cyan-500 text-white', hex: '#06b6d4' },
  SUBMITTED: { className: 'dark:bg-orange-500 bg-orange-300 text-white', hex: '#f97316' },
  PENDING: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  PENDING_APPROVAL: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  APPROVED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  ACCEPTED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  COMPLETED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  ACTIVE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  INACTIVE: { className: 'dark:bg-zinc-700 bg-zinc-500 text-white', hex: '#71717a' },
  REVOKED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  UNDER_MAINTENANCE: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  REJECTED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  CANCELLED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  CLOSED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  ARCHIVED: { className: 'dark:bg-stone-700 bg-stone-500 text-white', hex: '#78716c' },
  EXPIRED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#C00001' },
  NEW: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  ACKNOWLEDGED: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  RESOLVED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  SUSPENDED: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  EXPIRY_SOON: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  CREATE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  UPDATE: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  DELETE: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  CREATED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  UPDATED: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  DELETED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  VERY_LOW: { className: 'dark:bg-emerald-800 bg-emerald-600 text-white', hex: '#059669' },
  LOW: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  low: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  MODERATE: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  MEDIUM: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  medium: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  HIGH: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  high: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  EXTREME: { className: 'dark:bg-red-800 bg-red-600 text-white', hex: '#b91c1c' },
  VERY_HIGH: { className: 'dark:bg-red-800 bg-red-600 text-white', hex: '#b91c1c' },
  CRITICAL: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  critical: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  BUG: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  FEATURE_REQUEST: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  COMPLIANT: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  OFI: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  MAJOR_NON_CONFORMITY: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#dc2626' },
  MINOR_NON_CONFORMITY: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  NON_APPLICABLE: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  NOT_APPLICABLE: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  NOT_ASSESSED: { className: 'dark:bg-gray-600 bg-gray-400 text-white', hex: '#9ca3af' },
  IN_PLACE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  IN_PLACE_WITH_CCW: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  NOT_TESTED: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  NOT_IN_PLACE: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  OPEN: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  CONTAINED: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  IMPLEMENTED: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  AUDIT_REQUESTED: { className: 'dark:bg-indigo-700 bg-indigo-500 text-white', hex: '#6366f1' },
  NOT_AUDITED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  CHANGES_SUBMITTED: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  CHANGES_REQUESTED: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  REQUEST_EVIDENCE: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  READ: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  UNREAD: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  FAILED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  COMPLETE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  INCOMPLETE: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  EFFECTIVE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  ALTERNATE_CONTROL: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  INEFFECTIVE: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  NO_VISIBILITY: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  NOT_IMPLEMENTED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  PARTIALLY_IMPLEMENTED: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  YES: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  NO: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  NOT_POSSIBLE: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  NON_COMPLIANT: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  COMPLIANT_WITH_LEGAL_EXCEPTION: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  NOT_STARTED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  EVIDENCE_UPLOADED: { className: 'dark:bg-indigo-700 bg-indigo-500 text-white', hex: '#6366f1' },
  QSA_REVIEW: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  GAP: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  FULLY_MET: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  PARTIALLY_MET: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  NOT_MET: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  SKIPPED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  ALL: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  OPENED: { className: 'dark:bg-green-900 bg-green-600 text-white', hex: '#16a34a' },
  REPLIED: { className: 'dark:bg-yellow-900 bg-yellow-600 text-white', hex: '#ca8a04' },
  REPORTED: { className: 'dark:bg-orange-900 bg-orange-600 text-white', hex: '#ea580c' },
  PHISHED: { className: 'dark:bg-red-900 bg-red-600 text-white', hex: '#dc2626' },
  AZURE: { className: 'dark:bg-blue-900 bg-blue-600 text-white', hex: '#3b82f6' },
  CONFLUENCE: { className: 'dark:bg-blue-900 bg-blue-600 text-white', hex: '#3b82f6' },
  ATTACHMENT: { className: 'dark:bg-violet-900 bg-violet-600 text-white', hex: '#7c3aed' },

  SIMULATION: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  POTENTIAL_THREAT: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  ACTUAL_THREAT: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  SAFE: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },

  DO_NOTHING: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  MOVE_TO_SPAM: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },

  DEFAULT: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  REDIRECT: { className: 'dark:bg-indigo-700 bg-indigo-500 text-white', hex: '#6366f1' },
  CUSTOM: { className: 'dark:bg-purple-700 bg-purple-500 text-white', hex: '#a21caf' },
  NANO_LEARNING: { className: 'dark:bg-pink-700 bg-pink-500 text-white', hex: '#db2777' },

  CONDITIONAL: { className: 'dark:bg-teal-700 bg-teal-500 text-white', hex: '#14b8a6' },
  // Vendor evaluation pipeline statuses
  AWAITING_REVIEW: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  PARSING: { className: 'dark:bg-cyan-700 bg-cyan-500 text-white', hex: '#06b6d4' },
  MAPPING: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  SCORING: { className: 'dark:bg-purple-700 bg-purple-500 text-white', hex: '#a855f7' },
  UNMATCHED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },
  QUEUED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  PENDING_SIGNOFF: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  // change the color of superseed to something that makes sense and we can fit in our platform, cant have color of critical high medium low in review approved
  SUPERSEDED: { className: 'bg-[#346cc7] dark:bg-[#2a5191] text-white', hex: '#4A607A' },
  PILOT: { className: 'dark:bg-purple-700 bg-purple-500 text-white', hex: '#a855f7' },
  RESTRICTED: { className: 'dark:bg-orange-700 bg-orange-500 text-white', hex: '#f97316' },
  RETIRED: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  PROHIBITED: { className: 'dark:bg-red-700 bg-red-500 text-white', hex: '#ef4444' },

  PUBLIC: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  INTERNAL: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  CONFIDENTIAL: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },

  // Organisational context register
  CONFIRMED: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
  NEEDS_REVIEW: { className: 'dark:bg-yellow-700 bg-yellow-500 text-white', hex: '#eab308' },
  MANUAL_ENTRY: { className: 'dark:bg-gray-700 bg-gray-500 text-white', hex: '#6b7280' },
  CONTEXT_ASSISTANT: { className: 'dark:bg-purple-700 bg-purple-500 text-white', hex: '#a855f7' },
  REGISTER_SYNC: { className: 'dark:bg-blue-700 bg-blue-500 text-white', hex: '#3b82f6' },
  AI_VERIFIED: { className: 'dark:bg-violet-700 bg-violet-500 text-white', hex: '#7c3aed' },
  RECENT: { className: 'dark:bg-amber-700 bg-amber-500 text-white', hex: '#f59e0b' },
  PROMOTED: { className: 'dark:bg-teal-700 bg-teal-500 text-white', hex: '#14b8a6' },
  GENERATING: { className: 'dark:bg-cyan-700 bg-cyan-500 text-white', hex: '#06b6d4' },
  READY: { className: 'dark:bg-green-700 bg-green-500 text-white', hex: '#22c55e' },
}

const normalizeStatusKey = (status?: string | null): string | null => {
  if (!status) return null
  return status
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_')
}

export const getGlobalStatusColor = (status?: string | null, fallback: string = DEFAULT_STATUS_COLOR): string => {
  const statusKey = normalizeStatusKey(status)
  if (!statusKey) return fallback
  return GLOBAL_STATUS_COLOR_CONFIG[statusKey]?.className ?? fallback
}

export const getGlobalStatusHexColor = (
  status?: string | null,
  fallback: string = DEFAULT_STATUS_HEX_COLOR
): string => {
  const statusKey = normalizeStatusKey(status)
  if (!statusKey) return fallback
  return GLOBAL_STATUS_COLOR_CONFIG[statusKey]?.hex ?? fallback
}
